export default __webpack_public_path__ + "static/media/dark_mode.a76aff9a.svg";